import React from 'react'

import { ModalContent } from 'shared/components/common/modal'

import Reservation from 'public/components/default_template/reservation/Reservation'
import { useFlags } from 'shared/components/common/feature_flags/useFlags'
import useIsClient from 'shared/js/hooks/useIsClient'
import { ReservationFormV2 } from 'public/components/default_template/reservation/ReservationFormV2'

export const ReservationModalContent = () => {
  const { ooReusableFlagAlpha: ooReservationWidgetV2 } = useFlags()
  const isClient = useIsClient()
  const shouldRenderV2 = isClient && ooReservationWidgetV2 === true
  const shouldRenderV1 = isClient && ooReservationWidgetV2 === false

  return (
    <ModalContent
      // disabling this bc it complains that there is no focusable element,
      // which is correct bc i'm deferring rendering the reservation component
      // until we are in the client and we have our feature flag
      // so we don't flash between the two variants
      disableFocusTrap={!shouldRenderV2 && !shouldRenderV1}
      wrapperClassName='reservationModalWrapper'
      contentClassName='reservationModalContent'
      slideIn={!shouldRenderV2}
      slideOut={!shouldRenderV2}
      ariaLabelledBy={'reservation-modal-title'}
    >
      <div className='reservation'>
        {shouldRenderV2 && <ReservationFormV2 isModal />}
        {shouldRenderV1 && <Reservation isModal />}
      </div>
    </ModalContent>
  )
}
